(() => {
  //console.log('Filters script loaded');
  const GetURLParams = (param) => {
    let params = new URLSearchParams(window.location.search);
    return params.get(param);
  };

  u_UpdateURLParams = (key, value) => {
    if ('URLSearchParams' in window) {
      const url = new URL(window.location);
      const params = Object.fromEntries(  
        new URLSearchParams(window.location.search)
      );
      let push_state = false;
      if (!value) {
        if (params.hasOwnProperty(key)) {
          push_state = true;  
        }
        url.searchParams.delete(key);
      }
      else if (decodeURIComponent(url.searchParams.get(key)) !== value) {
        url.searchParams.set(key, encodeURIComponent(value));
        push_state = true;
      }
      if (push_state) {
        //console.log('updating param', key, value);
        history.pushState(null, '', url);
      }
    }
  }

  let SESSION_FRAMES_KEY = '_frames';
  let SESSION_FRAMES = JSON.parse(sessionStorage.getItem(SESSION_FRAMES_KEY)) || {};

  const LoadFrames = async (BRAND, context) => {
    let section_id = 'collection-frames';
    // fetch collection without "frame" for full list
    let path = window.location.pathname;
    if (path.indexOf('/collections/') == -1) {
      path = '/collections/replacement-lenses';
    }
    let url = `${ path }?filter.p.m.product.brand=${BRAND}&sections=${section_id}`;
    // console.log(url);
    let frames = [];
    let paginate;

    if (!context && !document.querySelector('#FacetFiltersForm')) return;

    const Load = async (page) => {
      let page_url = encodeURI(`${ url }&page=${ page }`);
      let res = await fetch(page_url, {cache: 'force-cache'}).then(res => res.json());
      if (!res[section_id]) return;

      let parser = new DOMParser();
      let $section = parser.parseFromString(res[section_id], 'text/html').body.querySelector('[data-frames]');

      let p_frames = JSON.parse($section.dataset.frames).flat();
      if (!paginate) {
        paginate = JSON.parse($section.dataset.paginate);
      }

      frames = [...new Set([...frames, ...p_frames])].sort();
      document.dispatchEvent(new CustomEvent('update:frames_list', {detail: {frames}}));
      if (page == paginate.pages) {
        SESSION_FRAMES[BRAND] = frames;
        sessionStorage.setItem(SESSION_FRAMES_KEY, JSON.stringify(SESSION_FRAMES));
        document.dispatchEvent(new CustomEvent('frames:loading:complete', {detail: {frames}}));
      }
    }

    let px = [];
    await Load(1);

    for(let n = 2; n <= paginate.pages; n++) {
      px.push(Load(n));
    }
    await Promise.all(px);
    // console.log(frames);
  }
  window.onload = () => {
    LoadFrames('Oakley');
  }

  // Product count functionality
  const setupProductCounter = () => {
    // Create the Alpine store for product count if Alpine is available
    if (window.Alpine) {
      window.Alpine.store('productCount', {
        visible: 0,
        total: 0,
        
        // Check if we're on a page that needs product counting
        isCounterEnabled() {
          return document.querySelector('.product-item') !== null;
        },
        
        // Update the count of visible product cards
        updateCount() {
          // Skip if we're not on a product listing page
          if (!this.isCounterEnabled()) return;
          
          // Count product items that are actually visible (parent not hidden)
          this.visible = 0;
          document.querySelectorAll('.product-item').forEach(product => {
            const parentGridItem = product.closest('.grid__item');
            if (parentGridItem && !parentGridItem.classList.contains('hidden')) {
              this.visible++;
            }
          });
          
          // Optionally track total for percentage calculations
          if (this.total === 0) {
            this.total = document.querySelectorAll('.product-item').length;
          }
          
          console.log('Product count updated:', this.visible, 'visible out of', this.total);
          
          // Dispatch event for non-Alpine components
          document.dispatchEvent(new CustomEvent('product-count:updated', {
            detail: { visible: this.visible, total: this.total }
          }));
        }
      });
    }
  };

  document.addEventListener('alpine:init', () => {
    // Initialize product counter before anything else
    setupProductCounter();
    
    let SELECTED_FILTERS = {};
    [...document.querySelectorAll('#FacetFiltersForm details')].forEach(($item) => {
      let filter_type = $item.dataset.filter_type;
      let param_name = $item.dataset.param_name;
      SELECTED_FILTERS[filter_type] = GetURLParams(param_name);
    });

    Alpine.data('FacetFiltersForm', () => ({
      SELECTED_FILTERS: SELECTED_FILTERS,
      flags: {
        is_filtered: false,
        is_MobileForm: false
      },
      init() {
        let am = this;
        am.UpdateFlags();
        document.addEventListener('facets:updated', () => {
          am.$el.querySelectorAll('details').forEach(($details) => {
            let filter_type = $details.dataset.filter_type;
            if (filter_type) {
              let param_name = $details.dataset.param_name;
              SELECTED_FILTERS[filter_type] = GetURLParams(param_name);        
            }
          });
          am.SELECTED_FILTERS = {...SELECTED_FILTERS};
          am.UpdateFlags();
        });

        am.$watch('SELECTED_FILTERS', am.UpdateFrameRemove.bind(am));
        am.UpdateFrameRemove();
        document.addEventListener('remove-frame', (e) => {
          // console.log(e)
          am.SELECTED_FILTERS.frame = '';
          am.UpdateFrameRemove();
        });

        document.body.addEventListener('trigger:filter:submit', Alpine.debounce(() => {
          const isDesktop = window.matchMedia('(min-width: 749px)').matches;
          if (isDesktop && am.flags.is_MobileForm) return;
          if (!isDesktop && !am.flags.is_MobileForm) return;

          let searchParams = new URLSearchParams(new FormData(am.$el));
          // remove blank values
          let paramsToDelete = [];
          searchParams.forEach((value, key) => {
            if (value == '') {
              paramsToDelete.push(key);
            }
          });
          paramsToDelete.forEach(key => {
            searchParams.delete(key);
          });
          let event_detail = {searchParams: searchParams.toString(), form: am.$el};
          document.body.dispatchEvent(new CustomEvent('FacetFilters:submit:ajax', { detail: event_detail }));
        }, 100));
        
        // Update product count after filter changes
        document.body.addEventListener('FacetFilters:submit:ajax', () => {
          setTimeout(() => {
            if (window.Alpine && window.Alpine.store('productCount')) {
              window.Alpine.store('productCount').updateCount();
            }
          }, 300);
        });
      },
      UpdateFlags() {
        let am = this;
        am.flags.is_filtered = Object.values(SELECTED_FILTERS).filter(value => value !== '').length !== 0;
        am.flags.is_MobileForm = am.$el.id == 'FacetFiltersFormMobile';
      },
      UpdateFrameRemove() {
        let am = this;
        let $removeFrame = am.flags.is_MobileForm ? document.querySelector('.facet-remove-frame-mobile') : am.$el.querySelector('.facet-remove-frame');
        if (!$removeFrame) return;
        $removeFrame.classList.toggle('hidden', !am.SELECTED_FILTERS['frame']);
        let params = new URLSearchParams(window.location.search);
        params.delete('filter.p.m.product.frame');
        $removeFrame.querySelector('a').setAttribute('href', `${window.location.pathname}?${params.toString()}`);
        $removeFrame.querySelector('.selected-frame').textContent = `Frame: ${am.SELECTED_FILTERS['frame']}`;
      },
      e_OnFilterChange(e) {
        let am = this;
        // Reset "frame" when "brand" selected
        if (e.target.name == 'filter.p.m.product.brand') {
          am.$el.querySelector('[name="filter.p.m.product.frame"]').value = '';
        }

        document.body.dispatchEvent(new CustomEvent('trigger:filter:submit'));
        //update count
        setTimeout(() => {
          if (window.Alpine && window.Alpine.store('productCount')) {
            window.Alpine.store('productCount').updateCount();
          }
        }, 300);
      }
    }));

    Alpine.data('FilterGroup', () => ({
      SELECTED_FILTERS: SELECTED_FILTERS,
      cache: {},
      filter_type: '',
      filter_values: [],
      flags: {
        is_Brand: false,
        is_Frame: false,
        is_disabled: false,
        is_dropdown: false,
        is_MobileForm: false,
        is_loading: false,
        is_CollectionPage: false
      },
      init() {
        let am = this;
        am.InitSelf();

        // dynamic logic for list updates
        am.UpdateList();
        am.$watch('SELECTED_FILTERS', am.UpdateList.bind(am));
        document.addEventListener('facets:updated', () => {
          SELECTED_FILTERS[am.filter_type] = am.cache.$details.dataset.selected;
          am.SELECTED_FILTERS = {...SELECTED_FILTERS};
        });
      },
      InitSelf() {
        let am = this;
        am.cache.$filtersForm = am.$el.closest('.FacetFiltersForm');
        am.cache.$details = am.$el.querySelector('details');
        am.cache.$select = am.$el.querySelector('select');

        am.filter_type = am.cache.$details.dataset.filter_type;
        am.filter_values = JSON.parse(am.cache.$details.dataset.filter_values);
        SELECTED_FILTERS[am.filter_type] = am.cache.$details.dataset.selected;
        am.SELECTED_FILTERS = {...SELECTED_FILTERS};

        am.UpdateFlags();
      },
      UpdateFlags() {
        let am = this;
        am.flags.is_Brand = am.filter_type == 'brand';
        am.flags.is_Frame = am.filter_type == 'frame';
        am.flags.is_dropdown = am.flags.is_Brand || am.flags.is_Frame;
        am.flags.is_disabled = !am.flags.is_Brand;
        am.flags.is_MobileForm = am.$el.closest('form').id == 'FacetFiltersFormMobile';
        am.flags.is_CollectionPage = document.body.classList.contains('template--collection');
      },
      UpdateList() {
        let am = this;
        if (!am.cache.$select) return;
        if (am.flags.is_Brand && am.flags.is_CollectionPage) {
          // Auto select First "Brand", if only 1 brand on collection (only on collection template)
          setTimeout(() => {
            if (am.flags.is_Brand && am.filter_values.length == 1) {
              let brand = am.filter_values[0];
              if (am.SELECTED_FILTERS['brand'] !== brand) {
                am.cache.$select.value = brand;
                am.cache.$select.dispatchEvent(new Event('change', {bubbles: true}));  
              }
            }  
          }, 0);

          // do not update list if "brand"
          return;
        }

        if (am.flags.is_Frame) {
          am.flags.is_disabled = !am.SELECTED_FILTERS['brand'] && 
            am.SELECTED_FILTERS[am.filter_type] == '';          
          
          // load frames
          if (am.SELECTED_FILTERS['brand'] !== '') {
            document.dispatchEvent(new CustomEvent('clear:frames_list'));
            document.addEventListener('update:frames_list', (e) => {
              setTimeout(() => {
                am.filter_values = [...e.detail.frames];
              }, 0);
            });

            let url_params = new URLSearchParams(window.location.search);
            if (am.SELECTED_FILTERS['frame'] != url_params.get('filter.p.m.product.frame')) {
              am.SELECTED_FILTERS['frame'] = url_params.get('filter.p.m.product.frame')
            }
            let frames_from_cache = SESSION_FRAMES[url_params.get('filter.p.m.product.brand')];
            if (frames_from_cache) {
              document.dispatchEvent(new CustomEvent('update:frames_list', {detail: {frames: frames_from_cache}}));
            }
            else {
              am.LoadFrames();
            }
          }
        }

        // filter out items that lead to 0
        let filter_values = JSON.parse(am.cache.$details.dataset.filter_values);
        let excludes = am.cache.$details.dataset.exclude_values;
        filter_values = filter_values.filter(item => excludes.indexOf(item) == -1);
        am.filter_values = [...filter_values];
      },
      LoadFrames() {
        let am = this;
        const isDesktop = window.matchMedia('(min-width: 749px)').matches;
        if (isDesktop && am.flags.is_MobileForm) return;
        if (!isDesktop && !am.flags.is_MobileForm) return;
        am.flags.is_loading = am.flags.show_framesLoading && true;
        document.dispatchEvent(new CustomEvent('frames:loading:start'));

        console.log(`LoadFrames--for--${ am.SELECTED_FILTERS.brand }!!`);
        LoadFrames(am.SELECTED_FILTERS.brand);        
      },
      e_OnFrameChange(e) {
        let am = this;
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('On Frame change!!');
        document.body.dispatchEvent(new CustomEvent('trigger:filter:submit'));
      }
    }));

    Alpine.data('FilterDropdownTop', () => ({
      SELECTED_FILTERS: SELECTED_FILTERS,
      selected: '',
      filter_type: '',
      filter_values: [],
      cache: {},
      flags: {
        is_Brand: false,
        is_Frame: false,
        is_disabled: false,
        is_dropdown: true,
        is_loading: false,
        show_framesLoading: false
      },
      init() {
        let am = this;
        am.filter_type = am.$el.dataset.filter_type;
        am.InitSelf();

        am.flags.is_Brand = am.filter_type == 'brand';
        am.flags.is_Frame = am.filter_type == 'frame';

        if (am.flags.is_Brand) {
          let filter_values = JSON.parse(am.cache.$main_list.dataset.filter_values);
          am.filter_values = [...filter_values];  
          am.selected = am.cache.$main_list.dataset.selected;
          document.addEventListener('facets:updated', () => {
            am.selected = am.cache.$main_list.dataset.selected;
          });
        }

        if (am.flags.is_Frame) {
          document.addEventListener('clear:frames_list', () => {
            am.filter_values = [];
          });

          document.addEventListener('update:frames_list', (e) => {
            am.filter_values = [...e.detail.frames].sort();
            let url_params = new URLSearchParams(window.location.search);
            am.selected = url_params.get('filter.p.m.product.frame');
          });

          ['frames:loading:start', 'frames:loading:complete'].forEach((event_type) => {
            document.addEventListener(event_type, (e) => {
              am.flags.is_loading = am.show_framesLoading && e.type == 'frames:loading:start' ? true : false;
            });
          });  
        }
        am.UpdateFlags();

        document.addEventListener('facets:updated', am.UpdateFlags.bind(am));

        am.$el.removeAttribute('x-cloak-filters');
      },
      InitSelf() {
        let am = this;
        const isDesktop = window.matchMedia('(min-width: 749px)').matches;
        am.cache.$filtersForm = isDesktop ? document.querySelector('#FacetFiltersForm') : document.querySelector('#FacetFiltersFormMobile');
        am.cache.$main_list = am.cache.$filtersForm.querySelector(`details[data-filter_type="${ am.filter_type }"]`);
      },
      UpdateFlags() {
        let am = this;
        am.flags.is_disabled = !am.flags.is_Brand;
        if (am.flags.is_Frame) {
          am.flags.is_disabled = !SELECTED_FILTERS['brand'];
        }
      },
      e_UpdateFilter(e) {
        let am = this;
        let selected = e.target.value;

        // trigger filter selection
        let $main_select = am.cache.$filtersForm.querySelector(`select[name="${ e.target.name }"]`);
        if ($main_select.value !== selected) {
          $main_select.value = selected;
          $main_select.dispatchEvent(new Event('change', {bubbles: true}));  
        }
      }
    }));

    const FRAME_FINDER_SECTION_ID = 'brand-frame-search-dropdown';
    Alpine.data('BrandFrameFinder', () => ({
      flags: {
        loaded: false,
        is_NotCollectionPage: true
      },
      selected: {
        Brand: '',
        Frame: ''
      },
      init() {
        this.InitSelf();
      },
      InitSelf() {
        let am = this;
        am.flags.is_NotCollectionPage = window.location.href.indexOf('/collections/') == -1;
        am.flags.loaded = am.$el.querySelectorAll('[x-data="BrandFrame_FinderItem"]').length !== 0;
        if (am.flags.is_NotCollectionPage && !am.flags.loaded) {
          am.FetchFinderForm();
        }
      },
      async e_FinderResults() {
        let am = this;
        let section_id = 'main-collection-product-grid';
        let collection_url = `/collections/replacement-lenses?filter.p.m.product.brand=${am.selected.Brand}`;
        if (am.selected.Frame) {
          collection_url += `&filter.p.m.product.frame=${am.selected.Frame}`;
        }
        collection_url = encodeURI(collection_url);
        let res_collection = await fetch(`${collection_url}&sections=${section_id}`).then(res => res.json());
        let $res_collection = UTILS.ConvertStringToHTML(res_collection[section_id]);
        let $products = $res_collection.querySelectorAll('.product-item');
        if ($products.length == 1) {
          let product_url = $products[0].dataset.productUrl;
          window.location.href = product_url;
        }
        else {
          window.location.href = collection_url;
        }
      },
      async FetchFinderForm() {
        let am = this;
        let url = `/collections/replacement-lenses?section_id=${FRAME_FINDER_SECTION_ID}`;
        let res_section = await fetch(url).then(res => res.text());
        let $res_section = UTILS.ConvertStringToHTML(res_section).querySelector('[x-data="BrandFrameFinder"]');
        // console.log(res_section, $res_section)
        am.$el.outerHTML = $res_section.outerHTML;
        am.flags.loaded = am.$el.querySelectorAll('[x-data="BrandFrame_FinderItem"]').length !== 0;;
      }
    }));

    Alpine.data('BrandFrame_FinderItem', () => ({
      flags: {
        is_loading: false,
        is_Frame: false
      },
      filter_name: '',
      filter_values: [],
      init() {
        this.InitSelf();
        this.InitWatchers();
      },
      InitSelf() {
        let am = this;
        am.filter_name = am.$el.dataset.filterName;
        am.flags.is_Frame = am.filter_values = am.filter_name == 'Frame';
        am.filter_values = am.flags.is_Frame ? [] : JSON.parse(am.$el.dataset.filterValues);
      },
      InitWatchers() {
        let am = this;
        am.$watch('selected.Brand', () => {
          if (am.flags.is_Frame) {
            am.filter_values = [];
            LoadFrames(am.selected.Brand, FRAME_FINDER_SECTION_ID);
            if (am.flags.is_Frame) {
              am.flags.is_loading = true;
            }
          }
        });

        if (am.flags.is_Frame) {
          document.addEventListener('frames:loading:complete', (e) => {
            // console.log(e);
            am.filter_values = [...e.detail.frames];
            am.flags.is_loading = false;
          });
        }
      }
    }));

    // Complete CustomFilters component with fixed clear methods

    // NOTE: "filter." has been removed from filter param names, because in liquid collection.filters object only returns active filters 
    Alpine.data('CustomFilters', () => ({
      filters: [],
      selected_filters: [],
      flags: {
        is_filtered: false
      },
      
      init() {
        this.InitWatchers();
        this.InitSelf();
      
      // Set up sync with external container for mobile
      this.$watch('selected_filters', () => {
        this.syncExternalFilters();
      });
      
      // Initial sync
      this.$nextTick(() => {
        this.syncExternalFilters();
      });
    },
    
    // Sync filters to external container
    syncExternalFilters() {
      const externalContainer = document.getElementById('mobile-active-filters-container');
      if (!externalContainer) return;
      
      // Get translations from theme variables
      const facets = window.themeVariables?.strings?.products?.facets || {};
      const translations = {
        clearFilter: facets.clear_filter || 'Remove filter',
        clearAll: facets.clear_all || 'Clear all'
      };
      
      if (this.selected_filters.length === 0) {
        externalContainer.innerHTML = '';
        return;
      }
      
      // Create the outer container with the class structure you want
      let html = '<div class="active-facets active-facets-mobile medium-hide large-up-hide">';
      
      // Add each filter button with the requested markup
      this.selected_filters.forEach(filter => {
        if (Array.isArray(filter.selected)) {
          filter.selected.forEach(item => {
            html += `
              <facet-remove data-filter_type="${filter.title.toLowerCase()}" data-filter_values="${filter.selected.length}">
                <a href="#" 
                   class="active-facets__button active-facets__button--light" 
                   data-filter-title="${filter.title}"
                   data-filter-value="${item}">
                  <span class="active-facets__button-inner button button--tertiary">
                    ${filter.title}: ${item}
                    <span class="svg-wrapper">
                      <svg aria-hidden="true" focusable="false" width="12" height="12" class="icon icon-close-small" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillcolor="currentColor" d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path></svg>
                    </span>
                    <span class="visually-hidden">${translations.clearFilter}</span>
                  </span>
                </a>
              </facet-remove>
            `;
          });
        } else if (filter.selected) {
          html += `
            <facet-remove data-filter_type="${filter.title.toLowerCase()}" data-filter_values="1">
              <a href="#" 
                 class="active-facets__button active-facets__button--light" 
                 data-filter-title="${filter.title}"
                 data-filter-value="${filter.selected}">
                <span class="active-facets__button-inner button button--tertiary">
                  ${filter.title}: ${filter.selected}
                  <span class="svg-wrapper">
                    <svg aria-hidden="true" focusable="false" width="12" height="12" class="icon icon-close-small" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillcolor="currentColor" d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path></svg>
                  </span>
                  <span class="visually-hidden">${translations.clearFilter}</span>
                </span>
              </a>
            </facet-remove>
          `;
        }
      });
  
      // Add the "Clear All" button
      html += `
        <facet-remove class="active-facets__button-wrapper facet-remove-all">
          <a href="#" class="active-facets__button-remove underlined-link">
            <span>${translations.clearAll}</span>
          </a>
        </facet-remove>
      </div>
      `;
      
      externalContainer.innerHTML = html;
      
      // Add event listeners to the new filter buttons
      externalContainer.querySelectorAll('.active-facets__button').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const filterTitle = button.getAttribute('data-filter-title');
          const filterValue = button.getAttribute('data-filter-value');
          
          if (filterTitle && filterValue) {
            // Find the filter in our store
            const filter = this.selected_filters.find(f => f.title === filterTitle);
            if (filter) {
              this.e_RemoveFilter(e, filter, filterValue);
            }
          }
        });
      });
      
      // Add event listener to the "Clear All" button
      const clearAllButton = externalContainer.querySelector('.facet-remove-all a');
      if (clearAllButton) {
        clearAllButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.e_ClearAllFilters();
        });
      }
    },
    
    // Helper function to create filter button HTML
    createFilterButtonHTML(title, value) {
      return `
        <a href="#" 
           class="active-facets__button active-facets__button--light" 
           role="button"
           data-filter-title="${title}"
           data-filter-value="${value}">
          <span class="active-facets__button-inner button button--tertiary">
            <span>${title}: ${value}</span>
            <span class="svg-wrapper">
              <svg aria-hidden="true" focusable="false" width="12" height="12" class="icon icon-close-small" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillcolor="currentColor" d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path></svg>
            </span>
            <span class="visually-hidden">Remove filter</span>
          </span>
        </a>
      `;
    },
      
      InitSelf() {
        this.filters = [...this.GetFiltersData()];
      },

      GetFiltersData() {
        let filters = [...this.$el.querySelectorAll('.filter-group-wrap[data-name]')].map($group => {
          // get filter values from url params

          let selected_url_params = GetURLParams($group.dataset.name);
          let selected = selected_url_params ? decodeURIComponent(selected_url_params) : false;
          if ($group.dataset.type == 'single') {
            selected = selected || '';
          } 
          else {
            selected = selected ? selected.split(',') : [];
          }

          return {
            title: $group.dataset.title,
            filter_name: $group.dataset.name.replace('filter.', ''),
            filter_values: JSON.parse($group.dataset.values),
            filter_key: $group.dataset.name.split('.').slice(-1)[0],
            filter_type: $group.dataset.type,
            selected: selected,
          }
        });
        // Remove duplicates
        let keys = new Set(filters.map(filter => filter.filter_name));
        filters = filters.filter(item => keys.has(item.filter_name) && keys.delete(item.filter_name));

        return filters;
      },
      
      InitWatchers() {
        // Watch filters array for changes and update the UI
        this.$watch('filters', () => {
          this.UpdateURLParams();
          this.RenderResults();
          this.$nextTick(this.UpdateFiltersVisibility.bind(this));
        });
        
        // Watch filters array for changes and update the selected_filters array
        this.$watch('filters', () => {
          this.flags.is_filtered = this.filters.filter(filter => {
            if (filter.filter_type === 'single') {
              return filter.selected !== '';
            } 
            else {
              return filter.selected.length !== 0;
            }
          }).length !== 0;
          
          let selected_filters = this.filters.filter(filter => {
            if (filter.filter_type === 'single') {
              return filter.selected !== '';
            } 
            else {
              return filter.selected.length !== 0;
            }
          }).map(filter => {
            return {
              title: filter.title,
              selected: filter.selected
            }
          });
          
          // Use spread to ensure reactivity
          this.selected_filters = [...selected_filters];
          
          console.log('selected_filters updated:', this.selected_filters);
        });


        // Handle URL changes and apply filters with query params
        window.addEventListener('popstate', (e) => {
          this.$nextTick(() => {
            this.filters = [...this.GetFiltersData()];
          });
        });
      },
      
      e_OnFilterChange(e) {
        let $group = e.target.closest('.filter-group-wrap');
        let filter = this.filters.find(filter => filter.filter_name == $group.dataset.name);

        if (filter.filter_type == 'single') {
          filter.selected = e.target.value;
      } else {
          let index = filter.selected.indexOf(e.target.value);
          if (index == -1) {
            filter.selected.push(e.target.value);
        } else {
            filter.selected.splice(index, 1);
          }
        }
        
        // Trigger a reactivity update
        this.filters = [...this.filters];
      },
      
      e_RemoveFilter(e, filter, selected_value) {
        console.log('Removing filter:', filter, selected_value);
        
      // Find the original filter in our filters array
        const originalFilter = this.filters.find(f => f.title === filter.title);
        
        if (originalFilter) {
          console.log('Found originalFilter:', originalFilter);
          
          if (originalFilter.filter_type === 'single') {
            originalFilter.selected = '';
          } else {
            const index = originalFilter.selected.indexOf(selected_value);
            if (index !== -1) {
              originalFilter.selected.splice(index, 1);
            }
          }
          
          // Update form elements
          const filterGroup = this.$el.querySelector(`.filter-group-wrap[data-name="${originalFilter.filter_name}"]`);
          if (filterGroup) {
            if (originalFilter.filter_type === 'single') {
              const select = filterGroup.querySelector('select');
              if (select) {
                select.value = '';
              }
            } else {
              const checkbox = filterGroup.querySelector(`input[value="${selected_value}"]`);
              if (checkbox) {
                checkbox.checked = false;
              }
            }
          }
          
          // Trigger reactivity updates
          this.forceUpdate();
        } else {
          console.error('Could not find original filter with title:', filter.title);
          console.log('Available filters:', this.filters);
        }
      },
      
      RenderResults() {
        let $product_grid = document.querySelector('#product-grid');
        if (!$product_grid) return;

        let filters_active = this.filters.filter(filter => {
          if (filter.filter_type === 'single') {
            return filter.selected !== '';
          } else {
            return filter.selected.length !== 0;
          }
        }).length !== 0;

        let selected_filters = this.filters.filter(filter => {
          if (filter.filter_type === 'single') {
            return filter.selected !== '';
          } else {
            return filter.selected.length !== 0;
          }
        });

        $product_grid.querySelectorAll('.grid__item').forEach(($product) => {
          let is_PromoItem = $product.classList.contains('grid-promo-block');
          if (is_PromoItem) {
            $product.classList.toggle('hidden', filters_active);
          } else {
            let dataset_values = [];
            for (let dataset_key in $product.dataset) {
              try {
                let values = JSON.parse($product.dataset[dataset_key]);
                values = Array.isArray(values) ? values : [values];
                dataset_values = [...dataset_values, ...values];
              } catch (e) {
                // Skip non-JSON values
              }
            }
            
            let matching_groups = selected_filters.map(filter => {
              if (filter.filter_type === 'single') {
                return dataset_values.includes(filter.selected);
              } else {
                return filter.selected.filter(value => dataset_values.includes(value)).length !== 0;
              }
            });
            
            let is_matching = matching_groups.filter(value => !value).length == 0;
            $product.classList.toggle('hidden', filters_active && !is_matching);
          }
        });
        
        // Update product count after rendering results
        setTimeout(() => {
          if (window.Alpine && window.Alpine.store('productCount')) {
            window.Alpine.store('productCount').updateCount();
          }
        }, 10);
      },
      
      UpdateFiltersVisibility() {
        let $products = [...document.querySelectorAll('.collection .grid__item:not(.grid-promo-block):not(.hidden) .product-item')];
        document.querySelectorAll('.filter-group-wrap').forEach($group => {
          let key = $group.dataset.filter_key;
          if (!key) return;

          let is_group_visible = false;
          $group.querySelectorAll('[title]').forEach($item => {
            let product_count = $products.filter($product => JSON.parse($product.dataset[key]).indexOf($item.title) !== -1).length;
            //console.log($item, $item.title, 'product_count:::', product_count, is_group_visible);
            $item.closest('li').classList.toggle('hidden', product_count == 0);
            if (!is_group_visible && product_count > 0) {
              is_group_visible = true;
            }
          });

          $group.classList.toggle('hidden', !is_group_visible);
        });
      },
      // Helper method to force Alpine UI updates
      forceUpdate() {
        // Create a new copy of the filters array to trigger reactivity
        this.filters = JSON.parse(JSON.stringify(this.filters));
        
        // Update selected_filters based on current filter state
        let selected_filters = this.filters.filter(filter => {
          if (filter.filter_type === 'single') {
            return filter.selected !== '';
          } else {
            return filter.selected.length !== 0;
          }
        }).map(filter => {
          return {
            title: filter.title,
            selected: filter.selected
          }
        });
        
        // Use spread to ensure reactivity
        this.selected_filters = [...selected_filters];
        
        // Update is_filtered flag
        this.flags.is_filtered = this.selected_filters.length > 0;
        
        // Render the results to update the product grid
        this.RenderResults();
        
        console.log('Force update called, selected_filters:', this.selected_filters);
        console.log('Force update called, is_filtered:', this.flags.is_filtered);
      },
      
      // Clear all filters
      e_ClearAllFilters() {
        // Reset all filter selections
        this.filters.forEach(filter => {
          if (filter.filter_type === 'single') {
            filter.selected = '';
          } else {
            filter.selected = [];
          }
        });

        // Reset all form inputs
        const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
          checkbox.checked = false;
        });

        const selects = this.$el.querySelectorAll('select');
        selects.forEach(select => {
          select.value = '';
        });
        
        // Force update to ensure Alpine reactivity
        this.forceUpdate();
        
        console.log('All filters cleared');
      },
      
      // Clear filters for a specific filter group
      e_ClearGroupFilters(filterName) {
        // Find the filter by name
        const filter = this.filters.find(f => f.filter_name === filterName);
        
        if (filter) {
          // Reset the filter selection
          if (filter.filter_type === 'single') {
            filter.selected = '';
          } else {
            filter.selected = [];
          }
          
          // Reset form inputs for this filter group
          const filterGroup = this.$el.querySelector(`.filter-group-wrap[data-name="${filterName}"]`);
          if (filterGroup) {
            const checkboxes = filterGroup.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
              checkbox.checked = false;
            });
            
            const select = filterGroup.querySelector('select');
            if (select) {
              select.value = '';
            }
          }
          
          // Force update to ensure Alpine reactivity
          this.forceUpdate();
          
          console.log(`Filters cleared for: ${filter.title}`);
        }
      },

      UpdateURLParams() {
        this.filters.forEach(item => {
          let param_name = item.filter_name;
          let param_value = item.selected.join(',');
          u_UpdateURLParams(param_name, param_value);
        })
      }
    }));


    Alpine.data('ProductCounter', () => ({
      // Local properties to display count
      displayText: '0 products',
      isEnabled: true,
      translationKeys: {
        // These should match Shopify's translation keys
        product_count: 'products.facets.product_count',
        product_count_simple: 'products.facets.product_count_simple'
      },
      translations: {
        // Default English translations as fallbacks
        'products.facets.product_count': '{{ product_count }} of {{ count }} products',
        'products.facets.product_count_simple': '{{ count }} products'
      },
      
      init() {
        console.log('ProductCounter initialized');
        
        // Check if we should enable the counter
        const store = Alpine.store('productCount');
        this.isEnabled = store && store.isCounterEnabled ? store.isCounterEnabled() : false;
        
        // Get the count display element
        const countElement = this.$el.querySelector('.mobile-facets__count');
        if (!countElement) {
          console.error('Count display element not found');
          return;
        }
        
        // Replace x-text directive with x-html pointing to our local property
        countElement.removeAttribute('x-text');
        countElement.setAttribute('x-html', 'displayText');
        
          // Initial count
        this.countAndUpdate();
          
        // Set up event listeners for filter changes
          document.addEventListener('facets:updated', () => {
          setTimeout(() => this.countAndUpdate(), 50);
          });
          
          document.body.addEventListener('FacetFilters:submit:ajax', () => {
          setTimeout(() => this.countAndUpdate(), 300);
          });
          
          document.addEventListener('collection:filtered', () => {
          setTimeout(() => this.countAndUpdate(), 50);
          });
        
        // Also listen for store updates
        document.addEventListener('product-count:updated', () => {
          this.countAndUpdate();
        });
      },
      
      // Count products and update display
      countAndUpdate() {
        // Count visible products
        const products = document.querySelectorAll('.product-item');
        let visibleCount = 0;
        
        products.forEach(product => {
          const parentGridItem = product.closest('.grid__item');
          if (parentGridItem && !parentGridItem.classList.contains('hidden')) {
            visibleCount++;
          }
        });
        
        const totalCount = products.length;
        
        console.log('Product count:', visibleCount, 'visible out of', totalCount);
        
        // Format the display text
        if (visibleCount === totalCount) {
          this.displayText = this.translations['products.facets.product_count_simple']
            .replace('{{ count }}', totalCount);
        } else {
          this.displayText = this.translations['products.facets.product_count']
            .replace('{{ product_count }}', visibleCount)
            .replace('{{ count }}', totalCount);
        }
        
        console.log('Updated display text:', this.displayText);
        
        // Force an update on the element directly as a fallback
        this.$nextTick(() => {
          const countElement = this.$el.querySelector('.mobile-facets__count');
          if (countElement) {
            countElement.innerHTML = this.displayText;
          }
        });
      },
      
      // This method is just here to satisfy the x-text binding if it's used
      formatCountMessage(visibleCount, totalCount) {
        return this.displayText;
      }
    }))
  });
})();

// Observer setup - outside the main closure to avoid scope issues
document.addEventListener('alpine:initialized', () => {
  //console.log('Alpine initialized, setting up product count observer');
  
  const setupProductCountObserver = () => {
    if (!window.Alpine || !window.Alpine.store('productCount')) return;
    
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;
    
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      mutations.forEach(mutation => {
        // Check if this is a relevant mutation (class changes on grid__item)
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'class' && 
            mutation.target.classList.contains('grid__item')) {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        //console.log('Grid item visibility changed, updating count');
        window.Alpine.store('productCount').updateCount();
      }
    });
    
    observer.observe(productGrid, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      subtree: true,
      childList: true
    });
    
    //console.log('Product count observer set up');
  };
  
  setupProductCountObserver();
});